import api from "./api";

export const getMeApi = () => api.get("/users/me");

// Fixed: survey summary uses the correct endpoint
export const getSurveySummaryApi = (slug) => api.get(`/survey/${slug}/selections`);

export const uploadPhotoApi = (file) => {
  const formData = new FormData();
  formData.append("photo", file);
  return api.post("/photo/profile", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};